import InsurancePlan from '../dto/InsurancePlan';

import type { BindRequirements } from '../dto/AgentDto';
import type { UserDto } from '../dto/UserDto';
import type { AgentLicense } from '../shared/AgentLicense';

export interface Agent extends UserDto {
  isAdmin: boolean;
  organizationName: string;
  licences: AgentLicense[];
  primaryContact: boolean;
  bindRequirements?: BindRequirements[];
}

export const agentCanBind = (agent: Agent, insurancePlan: InsurancePlan): boolean => {
  const insurancePlanRequirements = agentInsurancePlan(agent, insurancePlan);
  return (
    (insurancePlanRequirements !== undefined &&
      Boolean(agent.bindRequirements?.filter(obj => obj.canBind))) ??
    false
  );
};

export const agentInsurancePlan = (agent: Agent, insurancePlan: InsurancePlan) => {
  const insurancePlanRequirements = agent.bindRequirements?.find(x =>
    x.insurancePlans?.find(y => y.toLowerCase() === InsurancePlan[insurancePlan].toLowerCase())
  );
  return insurancePlanRequirements;
};

export default Agent;
